var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selector year-selector",attrs:{"clearable":false,"searchable":false,"options":_vm.availableYears,"value":_vm.$store.state.yearFilter},on:{"input":_vm.changeYear,"search:focus":_vm.fixHighlight}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(" Ano não arquivado! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }